var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgContactFormSubmittedErrorIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.3767 7.58338C43.9445 6.80106 43.3106 6.14887 42.5409 5.6947C41.7711 5.24053 40.8937 5.00098 40 5.00098C39.1063 5.00098 38.2289 5.24053 37.4591 5.6947C36.6894 6.14887 36.0555 6.80106 35.6233 7.58338L3.12333 67.5834C2.70306 68.3446 2.48857 69.2022 2.50102 70.0717C2.51348 70.9411 2.75247 71.7923 3.19438 72.5411C3.63629 73.29 4.26585 73.9107 5.02092 74.3419C5.776 74.7731 6.63047 75 7.5 75H72.5C73.3695 75 74.224 74.7731 74.9791 74.3419C75.7341 73.9107 76.3637 73.29 76.8056 72.5411C77.2475 71.7923 77.4865 70.9411 77.499 70.0717C77.5114 69.2022 77.2969 68.3446 76.8767 67.5834L44.3767 7.58338Z",
    stroke: "#EA80FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 60C40.3315 60 40.6495 60.1317 40.8839 60.3661C41.1183 60.6005 41.25 60.9185 41.25 61.25",
    stroke: "#EA80FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.75 61.25C38.75 60.9185 38.8817 60.6005 39.1161 60.3661C39.3505 60.1317 39.6685 60 40 60",
    stroke: "#EA80FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40 62.5C39.6685 62.5 39.3505 62.3683 39.1161 62.1339C38.8817 61.8995 38.75 61.5815 38.75 61.25",
    stroke: "#EA80FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.25 61.25C41.25 61.5815 41.1183 61.8995 40.8839 62.1339C40.6495 62.3683 40.3315 62.5 40 62.5",
    stroke: "#EA80FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40 50V27.5",
    stroke: "#EA80FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgContactFormSubmittedErrorIcon;